import { Button, Grid } from "@mui/material";
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import React, { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import PageLoader from "../commoncomponents/PageLoader";
import "../commoncomponents/print.css";
import MaintenanceWorkOrder from './Repairreportform';
const Kpirepairdownload = (props) => {
  const [loading, setLoading] = useState(false);
  const facilityId = getFacilityId('facilityId');
  const printRef = useRef();
  const runOnce = useRef(true);
  const token = getAuthToken("id_token");
  const { reportdata, onRenderComplete, year, serviceType, dataForReport, Id, typeCodeId, taskCodeId, setCloseViewLoader } = props;
  useEffect(() => {

    if (onRenderComplete) {
      onRenderComplete();
    }
  }, [onRenderComplete]);


  useEffect(() => {
    if (props.autoDownload && runOnce.current) {

      if (props.reportdata) {
        handleDownloadPDF();
        runOnce.current = false;
      }
    }
  }, [props.reportdata, props.autoDownload]);


  const handlePrint = useReactToPrint({
    content: () => printRef.current,

  });

  const handleDownloadPDF = async () => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work

    try {
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      const printElement = printRef.current;
      const records = printElement.querySelectorAll('.record-paper');
      let pageNumber = 1;

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const addContentToPDF = (canvas, imgData) => {
        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;
        let yOffset = 0;

        while (yOffset < imgHeight) {
          if (pageNumber > 1) {
            pdf.addPage();
          }

          const sliceHeight = Math.min(pdfHeight, imgHeight - yOffset);
          pdf.addImage(
            imgData,
            'PNG',
            0,
            -yOffset,
            imgWidth,
            imgHeight,
            undefined,
            'FAST'
          );

          // Add footer
          pdf.setFontSize(8);


          pageNumber++;
          yOffset += pdfHeight;
        }
      };

      const processRecord = async (record, index) => {
        return html2canvas(record, {
          scale: 2,
          useCORS: true,
        })
          .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            addContentToPDF(canvas, imgData);

            if (index === records.length - 1) {
              // pdf.save('SCHEDULED_MAINTENANCE_WORK_ORDER.pdf');
            }
          })
          .catch((error) => {
            console.error('Error generating PDF:', error);
          });
      };

      // Process all records and wait for all to complete
      await Promise.all(Array.from(records).map(processRecord));
      pdf.save('SCHEDULED_MAINTENANCE_WORK_ORDER.pdf');
      setLoading(false); // Now, this will run only after all records are processed
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setCloseViewLoader(false);
    props.setOpenModal(false);
  };

  return (
    <>
      <PageLoader open={loading} />
      <Grid container justifyContent="flex-end">
        <Grid item>
          <Button variant="contained" onClick={handlePrint} style={{ marginRight: '8px' }}>Print</Button>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={handleDownloadPDF} style={{ marginRight: '8px' }}>Download</Button>

        </Grid>
        <Grid item>
          <Button variant="contained" onClick={handleClose}>Close</Button>
        </Grid>
      </Grid>
      <MaintenanceWorkOrder
        ref={printRef}
        reportdata={reportdata}
        year={year}
        service={serviceType}
        taskCodeId={taskCodeId}
        typeCodeId={typeCodeId}
      />

    </>
  );
};

export default Kpirepairdownload;
